module.exports = __webpack_public_path__ + "img/spermegg.4f5908ce.png";